import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const editAddressMutation = gql`
  mutation editAddress(
    $token: String!
    $validatorId: String!
    $customerId: String!
    $subjectId: String!
    $addressId: String!
    $status: AddressStatus!
    $bedroomIdentifier: String!
    $name: String!
    $line1: String!
    $line2: String!
    $city: String!
    $postcode: String!
    $country: String!
    $equifaxId: String!
  ) {
    editAddress(
      token: $token
      validatorId: $validatorId
      customerId: $customerId
      subjectId: $subjectId
      addressId: $addressId
      status: $status
      bedroomIdentifier: $bedroomIdentifier
      name: $name
      line1: $line1
      line2: $line2
      city: $city
      postcode: $postcode
      country: $country
      equifaxId: $equifaxId
    )
  }
`

export type MutationVars = {
  token: string
  validatorId: string
  customerId: string
  subjectId: string
  addressId: string
  status: string
  bedroomIdentifier: string
  name: string
  line1: string
  line2: string
  city: string
  postcode: string
  country: string
  equifaxId: string
}

export type EditAddressData = {
  editAddress: string | unknown
}

export const useEditAddressMutation: WrappedMutation<
  EditAddressData,
  MutationVars
> = () =>
  useMutation<EditAddressData, MutationVars>(editAddressMutation, {
    client: agentClient,
  })
